export const logReportConfigFieldlabels = {
  logConfigId: 'Log Report Config ID',
  applicationName: 'Application Name',
  mailID: 'Email',
  enableNotification: 'Enable Notification',
  status: 'Status'
}
